import { render } from "./UserSearchBar.vue?vue&type=template&id=328d963f"
import script from "./UserSearchBar.vue?vue&type=script&lang=js"
export * from "./UserSearchBar.vue?vue&type=script&lang=js"

import "./UserSearchBar.vue?vue&type=style&index=0&id=328d963f&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__